import dynamic from 'next/dynamic';
const ProductCarousel = dynamic(() => import('./Carousel/ProductCarousel'));


const ProductCarouselContainer = (props) => {
    const {
        productData,
        products,
        package_core,
        long_term,
        title = "",
        addToQuoteComponent = true,
        color = "primary",
        className = "ml-3"
    } = props;

    // const { checkScreenSize} = useWindowSize()

    return (
        <>
            {/* <h4 className='ml-2'>{title}</h4> */}

            {title && <h4 style={{color: `var(--color-${color})`}} className={className}>{title}</h4>}
       
            <ProductCarousel
                productData={productData}
                products={products}
                package_core={package_core}
                long_term={long_term} 
                addToQuoteComponent={addToQuoteComponent}
            />
    
        </>
    )
}

export default ProductCarouselContainer